module.exports = "export { default } from './lozenge';\nexport type { ThemeAppearance, LozengeProps } from './lozenge';\n"